var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI1MotorbikeParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#I1_Motorbike_parking_svg__clip0)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76 22V0H55v22h21zM56 36c0-1.66 2-3 5-3v6c-3 0-5-1.34-5-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.722 64.357A12.24 12.24 0 0073 57.25a12.2 12.2 0 00-5.17-9.89 11.898 11.898 0 00-1.64-1 14.06 14.06 0 00-1.8-.72 12.003 12.003 0 00-3.63-.55 8.497 8.497 0 00-.88 0c-.15 0-.19-.02-.44 0s-.5.11-.74.11l-.67.13-.39.1L51 28h-8a1.5 1.5 0 100 3h6l1.43 3.81C44.85 33.91 37.71 37.93 36 43h-4l-5.89-4H13v3c11.14-1.49 16.21 5.42 17.78 11.87.159.699.233 1.414.22 2.13h-2.7a12.27 12.27 0 00-8.51-10.37 12.129 12.129 0 00-3.63-.55h-1.32c-.26.03-.52.12-.77.12l-.48.1-.81.2-.21.06a12.25 12.25 0 002.39 23.86c.399.04.8.06 1.2.06a12.15 12.15 0 0012.09-10.57h2.86V62h10.87a3 3 0 003-3v-4.35c.39-3.36 2.13-8.49 8.52-11.91l1.5 3.74v.06a12.12 12.12 0 00-6.47 10.7 12.27 12.27 0 0014.68 12 12.24 12.24 0 007.512-4.883z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "I1_Motorbike_parking_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h76v76H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/I1_Motorbike_parking.1082f9ef.svg";
export { SvgI1MotorbikeParking as ReactComponent };